import { useEffect, useState } from 'react';

import { Form } from 'antd';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { DetailPropertyComponent } from 'presentation/components/DetailProperty';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    completeFetching,
    showAlert,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { Detail } from '../CU-031-01/components/Detail';
import { DetailProperty } from '../CU-031-01/models/DetailProperty';
import { NumberAndTitle } from '../CU-033-01/components/NumberAndTItle';
import { CU036003Modal } from '../CU-036-03';
import { ConfirmModalComponent } from './components/ConfirmModal';
import { DesiredSellingPrice } from './components/DesiredSellingPrice';
import { SellingPrice } from './models/Property';

const HARD_CODE = {
    DEAL_DETAIL_EXPLANATION_REQUESTED: true,
    STATUS_PROCESS_WF: 'DONE',
};
const DEMO_DESCRIPTION =
    '説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります';
interface props {
    propertyUseCase: PropertyUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
}
const CU03601Page = ({ propertyUseCase, masterUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { propertyId, registeredId, auctionId } = useParams();

    const [detailProperty, setDetailProperty] = useState<DetailProperty>();
    const [detailAssessment, setDetailAssessment] = useState<SellingPrice>();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const visibleModalCU03603 = useAppSelector((state) => state.CU03603Slice.isVisibleCU03603);
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            if (storedInput) form.setFieldsValue(storedInput);
            await Promise.all([
                getDetailProperty({ propertyId: Number(propertyId) }),
                getListedPropertyRoomGetAssessmentDetail({
                    listedPropertyId: Number(registeredId),
                }),
            ]);
        })();
    }, []);

    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());

            let response = null;
            if (auctionId) {
                response = await propertyUseCase.getSellingPrice({
                    auctionId: Number(auctionId),
                });
            } else {
                response = await propertyUseCase.getDefaultSellingPrice(params);
            }
            const detail = response.result;
            if (detail) {
                setDetailAssessment(detail);
                const askingSalePriceLowerLimit =
                    detail.askingSalePriceLowerLimit || detail.askingSalePriceLowerLimit === 0
                        ? commonHelpers.roundTenThousandYen(detail.askingSalePriceLowerLimit)
                        : null;
                const askingSalePriceUpperLimit =
                    detail.askingSalePriceUpperLimit || detail.askingSalePriceUpperLimit === 0
                        ? commonHelpers.roundTenThousandYen(detail.askingSalePriceUpperLimit)
                        : null;

                form.setFieldsValue({
                    askingSalePriceLowerLimit: askingSalePriceLowerLimit,
                    askingSalePriceUpperLimit: askingSalePriceUpperLimit,
                });
                if (askingSalePriceLowerLimit !== null && askingSalePriceUpperLimit !== null) {
                    setIsDisabled(false);
                }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const getDetailProperty = async (params: { propertyId: number }) => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getDetailProperty(params);
            if (response.result) setDetailProperty(response.result);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const submit = async (statusProcessWf?: string) => {
        const value = form.getFieldsValue();
        try {
            dispatch(startFetching());
            if (!registeredId) return;

            if (auctionId) {
                const response = await propertyUseCase.auctionPriceLimitUpdate({
                    auctionId: Number(auctionId),
                    askingSalePriceLowerLimit: value.askingSalePriceLowerLimit * 10000,
                    askingSalePriceUpperLimit: value.askingSalePriceUpperLimit * 10000,
                });
                if (response.status === '200') {
                    openSuccessNoti({
                        description: getMessage('S0313', '変更する'),
                    });
                }
            } else {
                const response = await propertyUseCase.putListedPropertySalePriceLimitUpdate({
                    listedPropertyId: Number(registeredId),
                    askingSalePriceLowerLimit: value.askingSalePriceLowerLimit,
                    askingSalePriceUpperLimit: value.askingSalePriceUpperLimit,
                    dealDetailExplanationRequested: !HARD_CODE.DEAL_DETAIL_EXPLANATION_REQUESTED,
                    statusProcessWf: statusProcessWf || HARD_CODE.STATUS_PROCESS_WF,
                });
                if (response.status === '200') {
                    openSuccessNoti({
                        description: getMessage(
                            'S0313',
                            statusProcessWf ? '下書きとして保存' : '出品する',
                        ),
                    });
                }
            }
            if (statusProcessWf) {
                backToDashboard();
            } else {
                setOpen(true);
            }
        } catch (error: any) {
            if (error && error.message) {
                const modalProps = {
                    title: '確認',
                    message: error.message,
                    type: 'warning',
                    okText: 'OK',
                    onOk: () => {
                        backToDashboard();
                    },
                };
                dispatch(showAlert(modalProps));
            } else {
                openErrorNoti();
            }
        } finally {
            dispatch(completeFetching());
        }
    };
    const registDealDetailExplanationRequested = async (hasRequest: boolean) => {
        const value = form.getFieldsValue();
        try {
            dispatch(startFetching());
            if (hasRequest) {
                const response = await propertyUseCase.putListedPropertySalePriceLimitUpdate({
                    listedPropertyId: Number(registeredId),
                    askingSalePriceLowerLimit: value.askingSalePriceLowerLimit,
                    askingSalePriceUpperLimit: value.askingSalePriceUpperLimit,
                    dealDetailExplanationRequested: HARD_CODE.DEAL_DETAIL_EXPLANATION_REQUESTED,
                    statusProcessWf: HARD_CODE.STATUS_PROCESS_WF,
                });
                if (response.status === '200') {
                    openSuccessNoti({
                        description: getMessage('S0313', '出品する'),
                    });
                    backToDashboard();
                }
            } else {
                backToDashboard();
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
            setOpen(false);
        }
    };

    const onChangePrice = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then((e) => {
                setIsDisabled(false);
            })
            .catch((e) => {
                setIsDisabled(e.errorFields.length > 0);
            });
    };

    const backToDashboard = () => {
        setOpen(false);
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`);
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                paddingLeft: 20,
            }}
            className="CU-033-01-container CU-031-01-container CU-036-01-container"
        >
            <CU036003Modal
                masterUseCase={masterUseCase}
                propertyUseCase={propertyUseCase}
                open={visibleModalCU03603}
            />
            <PageTitle title={auctionId ? '価格変更申請' : '査定結果（物件調査と銀行評価で算出しました）'} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {detailProperty ? (
                    <section style={{ display: 'inline-block' }}>
                        <Detail data={detailProperty} />
                        <div style={{ height: 12 }}></div>
                        <DetailPropertyComponent
                            link={`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_02}/${propertyId}/${registeredId}`}
                        />
                    </section>
                ) : null}

                <section
                    style={{
                        width: 363,
                        height: 'fit-content',
                        margin: '0px 0px 0px 69px',
                        padding: 0,
                    }}
                >
                    <div className="title-badge badge-1 center-inside">想定売却価格</div>
                    <div
                        style={{ marginTop: 40, marginBottom: 40, width: '100%' }}
                        className="center-inside"
                    >
                        <div>
                            <span className="title-1 mr-[8px]">
                                {commonHelpers.formatNumberMoney(
                                    commonHelpers.roundTenThousandYen(
                                        detailAssessment?.marketPrice,
                                    ),
                                )}
                            </span>
                            <span className="title-1-unit">万円</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <NumberAndTitle
                            num={detailAssessment?.marketPriceGrossIncome ?? 0}
                            tit="上記価格で売却した場合の手残り"
                            roundfunction={commonHelpers.convertTenThousandYenDown}
                        />
                    </div>
                    {/* <div className="title-badge badge-2 center-inside" style={{ marginTop: 33 }}>
                        相場価格の根拠
                    </div>
                    <MoreInfo description={DEMO_DESCRIPTION} /> 
                    <Button
                        className="button-login-text button-blue-custom"
                        style={{
                            width: '100%',
                            height: 56,
                            marginTop: 18,
                            marginBottom: 24,
                        }}
                        // disabled={isDisabled}
                    >
                        周辺取引事例を見る
                    </Button> */}
                    <br></br>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: 33,
                        }}
                    >
                        <NumberAndTitle num={detailAssessment?.nrbxPrice ?? 0} tit="当社買取価格" />
                        <NumberAndTitle
                            num={detailAssessment?.nrbxPriceGrossIncome ?? 0}
                            tit="当社買取価格に対する手残り"
                            roundfunction={commonHelpers.convertTenThousandYenDown}
                        />
                        <div></div>
                    </div>
                    <div>
                        <h3>想定売却価格で売却した場合の手残りの計算式</h3>
                        <div className="calculation-formula">
                            想定売却価格 - (想定売却価格 x 3% + 6万円) x 1.1 - 残債価格<br/>
                            例 2000万円 - <span className="hightlight-color">( 2000万円 x 3% + 6万円)</span> x 1.1 - 1000万円 = 927.4万円<br/>
                            <span className="hightlight-color">※仲介手数料</span>
                        </div>
                    </div>
                    <div>
                        <h3>当社買取価格に対する手残りの計算式</h3>
                        <div className="calculation-formula" style={{ marginBottom: 30 }}>
                            当社買取価格 - 残債価格<br/>
                            例 2000万円 - <span className="hightlight-color">0</span> - 1000万円 = 1000万円<br/>
                            <span className="hightlight-color">※仲介手数料がかかりません</span>
                        </div>
                    </div>
                    <Form
                        form={form}
                        className="desired-selling-container"
                        onValuesChange={onChangePrice}
                        style={{ margin: 0 }}
                        onFinish={() => setOpen(true)}
                    >
                        <DesiredSellingPrice
                            form={form}
                            data={detailAssessment}
                            isDisabled={isDisabled}
                            onSubmit={submit}
                            auctionId={auctionId}
                        />
                    </Form>
                    <ConfirmModalComponent
                        onCancel={() => registDealDetailExplanationRequested(false)}
                        onOk={() => registDealDetailExplanationRequested(true)}
                        open={open}
                    />
                </section>
            </section>
        </div>
    );
};
export default CU03601Page;
